import React from "react";
import Typography from "@material-ui/core/Typography";
import StarIcon from "@material-ui/icons/Star";
import WifiIcon from "@material-ui/icons/Wifi"
import CoffeeMug from "../../assets/img/coffee-cup.png";
import ReviewIcon from '@material-ui/icons/ChatBubble'

export default function MediaControlCard(props) {
  const { hotel } = props;

  const onHotelHover = () => {
    if (props.onHotelHover) {
      const { hotel } = props;
      props.onHotelHover({ title: hotel?.meta_data?.name, lat: parseFloat(hotel?.meta_data?.latitude), lng: parseFloat(hotel?.meta_data?.longitude) })
    }
  }

  const getImage = (meta_data) => {
    if (meta_data.hero_images && meta_data.hero_images.length > 0) {
      if (meta_data?.hero_images[0].links.m) {
        return meta_data?.hero_images[0].links?.m?.href
      } else if (meta_data?.hero_images[0].links.s) {
        return meta_data?.hero_images[0].links.s.href
      } else if(meta_data?.hero_images[0].links.l) {
        return meta_data?.hero_images[0].links.l.href
      }
    } else if (meta_data.images && meta_data.images.length > 0) {
      let url = ''
      meta_data.images.map((im) => {
        if (im.hero_image) {
          if (im.links.m) {
            url = im.links?.m?.href
          } else if (im.links.s) {
            url = im.links.s.href
          } else if(im.links.l) {
            url = im.links.l.href
          }
        }
      })
      if (url == '') {
        if (meta_data.images[0].links.m) {
          url = meta_data.images[0].links?.m?.href
        } else if (meta_data.images[0].links.s) {
          url = meta_data.images[0].links.s.href
        } else if(meta_data.images[0].links.l){
          url = meta_data.images[0].links.l.href
        }
      }
      return url
    }
    return ''
  }


  return (
    <a href={'#'} className="hotel-card-link" target="_blank" onMouseOver={onHotelHover}>
      <div
        className="hotel-card"
        style={{ display: "flex", flexDirection: "row", minHeight: 180 }}
      >
        <div
          className="hotel-card-thumb"
          style={{ flex: 2, background: `url('https://property-gallery.rakutentravelxchange.com/${hotel.meta_data.id}/${getImage(hotel.meta_data)}') no-repeat` }}
        ></div>
        <div style={{ flex: 4, padding: 20 }}>
          <div
            className="flexRow"
          >
            <Typography component="p" className="hotel-name clipped-label" style={{ fontSize: '20px' }}>{hotel?.meta_data?.name}</Typography>
            <Typography component="p">
              {hotel?.rates?.packages[0].room_rate_currency} {hotel?.rates?.packages[0].room_rate}
            </Typography>
          </div>
          <div
            className="flexRow" style={{ justifyContent: 'flex-start', marginTop: '5px' }}
          >
            <Typography component="p" className="text-left">
              {hotel?.meta_data?.rating}{" "}
              <StarIcon style={{ color: "var(--green)", fontSize: "20px", marginTop: '-5px' }} />
            </Typography>

            <Typography component="p" style={{ marginLeft: '30px' }}>
              {hotel.reviewCount}
              <ReviewIcon style={{ color: "var(--green)", fontSize: "20px", marginTop: '-3px', marginLeft: '5px' }} />
            </Typography>
          </div>
          <div
            className="flexRow" style={{ justifyContent: 'flex-start', marginTop: '5px' }}
          >
            <Typography component="p" className="text-left">
              {hotel?.meta_data?.address}{" "}
            </Typography>
          </div>
          <div
            className="flexRow" style={{ marginTop: '12px' }}
          >
            {hotel.includeBreakfast && <Typography component="p" className="text-left">

              <img src={CoffeeMug} style={{ height: '20px', width: '20px', marginRight: '5px' }} />
              Free Breakfast
            </Typography>}

            {hotel.freeWifi && <Typography component="p" className="text-left">

              <WifiIcon style={{ color: "var(--darker)", fontSize: "20px", marginRight: '5px' }} />
              Free Wifi
            </Typography>
            }
          </div>

        </div>
      </div></a>
  );
}

// <div style={{ width: '100%' }}>
//     <Card className={classes.root}>
//         <CardMedia
//             className={classes.cover}
//             image={hotel.imageURL}
//             title={hotel.hotelName}
//         />
//         <div className={classes.details}>
//             <CardContent className={classes.content}>
//                 <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between'}}>
//                 <Typography component="p" >
//                     {hotel.hotelName}
//                 </Typography>
//                 <Typography component="p" >
//                 {hotel.currency} {hotel.dailyRate}
//                 </Typography>
//                 </div>

//                 <Typography component="p" >
//                     {hotel.starRating} <StarIcon style={{color:'rgb(104 217 47)',fontSize:'20px'}}/>
//                 </Typography>
//                 <Typography  component="p" >
//                     Daily rate {hotel.currency} {hotel.dailyRate}
//                 </Typography>
//             </CardContent>
//             <div className={classes.controls}>

//             </div>
//         </div>
//     </Card>
// </div>
